import { Capacitor } from '@capacitor/core';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import {
  EmailAuthProvider,
  signInWithCredential,
  signOut as firebaseSignOut,
  User,
} from 'firebase/auth';
import { auth } from '../firebase/client';

const isBrowser = typeof window !== 'undefined';
const isNativePlatform = isBrowser && typeof Capacitor !== 'undefined' && Capacitor.isNativePlatform();

export const isNativeFirebaseAuth = () => isNativePlatform;

export const nativeEmailPasswordSignIn = async (
  email: string,
  password: string,
): Promise<User | null> => {
  if (!isNativePlatform) {
    return null;
  }

  // Ensure plugin available (web builds include a stub implementation)
  await FirebaseAuthentication.signInWithEmailAndPassword({
    email,
    password,
  });

  const credential = EmailAuthProvider.credential(email, password);
  const credentialResult = await signInWithCredential(auth, credential);
  return credentialResult.user;
};

export const nativeSignOut = async () => {
  if (!isNativePlatform) {
    return;
  }

  try {
    await FirebaseAuthentication.signOut();
  } finally {
    await firebaseSignOut(auth);
  }
};
